<template>
  <nav>
    <img alt="Wish logo" src="../assets/clochette.png">
    <a class="logoff f" v-on:click="logoff()"><span class="fa fa-sign-out ico"></span> déconnexion</a>
    <select class="select-small" v-model="currentUserName" @change="onChange($event)">
      <option disabled value="">Please select one</option>
      <option v-for="u in users" v-bind:key="u.username">
        {{u.username}}
      </option>
    </select>
    <ul class="select-big">
      <li v-for="u in users" v-bind:key="u.username">
        <a :class="{
          m: (u.sex == 'm'),
          f: (u.sex == 'f'),
          active: (u.username == currentUserName)
          }" v-bind:href="'/list/' + u.username">{{u.username}}</a>
      </li>
    </ul>
    <a class="amazon m" target="_blank" href="https://www.amazon.fr/b?_encoding=UTF8&tag=wishlistpourn-21&linkCode=ur2&linkId=4acdc1500a3c83f34b687da3b1c519a6&camp=1642&creative=6746&node=322086011">
      <img alt="Amazon logo" src="../assets/amazon.png">
    </a>
  </nav>
</template>

<script>
export default {
  props: ['users'],
  mounted () {
      if(typeof this.$route.params.user === 'undefined' ) {
          this.currentUserName = this.$oauth.getCurrentUser()
      } else {
          this.currentUserName = this.$route.params.user
      }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log(to)
      console.log(from)
      this.$emit("changeUser", to.params.user)
    }
  },
  methods: {
      onChange(event) {
          this.$router.push({name: "userlist", params: {user: event.target.value}})
      },
      logoff(){
        this.$oauth.logOff()
      }
  },
  data () {
      return {
        currentUserName: ""
      }
  }
}
</script>

<style>

@media only screen and (max-width: 600px) {
  .select-small { display: block; width: 100%; font-size: 2em;}
  .select-big { display: none; }

  /* The sidebar menu */
  nav {
    width: 100%;
    z-index: 1;
    top: 0; 
    left: 0;
    overflow-x: hidden; 
  }

}
@media only screen and (min-width: 601px) {
  .select-small { display: none; }
  .select-big { display: block; }

  /* The sidebar menu */
  nav {
    height: 100%; 
    z-index: 1;
    overflow-x: hidden; 
    flex: 25%;
    min-width: 255px;
    max-width: 320px;
  }
  .amazon { margin-top: 20px;}
  .logoff { margin-bottom: 20px;}
}

.active { background-color: lightgrey;}
.logoff > .ico {font-size: 1em;}
.m {color: lightseagreen}
.f {color:indianred}

/* The navigation menu links */
nav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 1.3em;
  display: block;
}

/* When you mouse over the navigation links, change their color */
a:hover {
  color: darkorchid;
}

</style>